import { all, fork } from 'redux-saga/effects';
import { createDatastoreAndRunnersSaga } from './CreateDataStoreAndRunners';
import { createRunnerSaga } from './CreateRunner';
import { getAllRunnersSaga } from './GetAllRunners';
import { stopRunnerSaga } from './StopRunner';
import { updateDataStoreAssociatedRunnersSaga } from './UpdateDatastoreAssociatedRunners';
import { updateRunnerSaga } from './UpdateRunner';

export default function* runnerSaga() {
  yield all([
    fork(createRunnerSaga),
    fork(createDatastoreAndRunnersSaga),
    fork(getAllRunnersSaga),
    fork(updateDataStoreAssociatedRunnersSaga),
    fork(stopRunnerSaga),
    fork(updateRunnerSaga),
  ]);
}
